module.exports = __webpack_public_path__ + "media/images/boxes/cms-box500-effac5fd941deb3ee0a2d37f08e71e7d.png";